export function routeFocusAction(navigationType, menuOrigin = false, hasPreviousFocus = false) {
  return navigationType === 'POP'
    ? { focus: menuOrigin ? 'navigation' : hasPreviousFocus ? 'previous' : 'content', restoreScroll: true }
    : { focus: 'content', restoreScroll: false };
}

export function restoreRouteState({ scrollTo, scrollTop, resolveFocus, observe, addInterrupt, requestFrame, cancelFrame, timeoutMs = 2000 }) {
  let stopped = false; let focused = false; let frame; let timer;
  const apply = () => { if (stopped) return; scrollTo(scrollTop); if (!focused) { const target = resolveFocus(); if (target) { target.focus({ preventScroll: true }); focused = true; } } };
  const tick = () => { apply(); frame = requestFrame(tick); };
  const stop = () => { if (stopped) return; stopped = true; if (frame !== undefined) cancelFrame(frame); clearTimeout(timer); disconnect(); removeInterrupt(); };
  const disconnect = observe(apply);
  const removeInterrupt = addInterrupt(stop);
  frame = requestFrame(tick); timer = setTimeout(stop, timeoutMs);
  return stop;
}
